import React from "react";

function Bridge() {
  return (
    <section className="bridge">
      <h2>The UAE–Sri Lanka Bridge</h2>

      <ul>
        <li><strong>Time Zone Alignment:</strong> Our staff works your hours.</li>
        <li><strong>Cost-Effective Excellence:</strong> High-end expertise at a fraction of UAE hiring costs.</li>
        <li><strong>Remote Ready:</strong> All staff are equipped for professional remote delivery.</li>
      </ul>
    </section>
  );
}

export default Bridge;